import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class StationResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.station).get(options);
  }

  get(id) {
    return this.$resource(apis.station + id).get();
  }

  heatmap(type) {
    return this.$resource(apis.station + "heatmap").get({ type });
  }

  search(query = "", params) {
    return this.$resource(apis.station + "autocomplete/").get(
      assign(params, { query })
    );
  }

  post(item) {
    const newItem = { ...item };
    const lng = item.loc.coordinates[0];
    const lat = item.loc.coordinates[1];
    newItem.loc.coordinates = { lng, lat };
    return this.$resource(apis.station).save(newItem);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.station + id + `/${name}`).save(item);
  }
  update(id, item) {
    return this.$resource(apis.station + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default StationResource;



// WEBPACK FOOTER //
// ./src/resources/station/station.resource.js